(function() { module.exports = window["Next"]["Switch"]; }());